const SET_MY_DOCUMENTS = 'SET_MY_DOCUMENTS';
const SET_SHARED = 'SET_SHARED';
const SET_MONTHLY_TX = 'SET_MONTHLY_TX';

export{
  SET_MY_DOCUMENTS,
  SET_SHARED,
  SET_MONTHLY_TX
};
